<template>
  <v-container>
    <carga-ciclo-semestre titulo="Carga Académica" :datos="periodo" />

    <v-divider />

    <v-card>
      <v-card-text>
        <v-row
          ><v-col cols="12" sm="5" md="4"
            ><v-select
              v-model="turno"
              :items="[
                { text: 'VESPERTINO', value: 'TV' },
                { text: 'MATUTINO', value: 'TM' },
              ]"
              label="Turno"
              required
          /></v-col>
          <v-col cols="12" sm="5" md="4" offset-sm="2" offset-md="4"
            ><v-btn
              block
              class="primary"
              :to="'/carga-academica-por-docente/' + periodoSeleccionado"
              >Carga por Docente</v-btn
            ><br />
            <v-btn
              block
              class="primary"
              @click="downloadTxt"
              v-if="arrayCargaCsv.length > 0"
              >Archivo para <br />horarios: Carga_{{
                turno.toUpperCase()
              }}</v-btn
            ><br />
            <download-csv
              :data="arrayClassroomCsv"
              class="v-btn primary v-btn--block text-center"
              v-if="arrayClassroomCsv.length > 0"
              :name="'info_classroom_' + turno.toLowerCase() + '.csv'"
              >Archivo CSV para <br />clases en Classroom</download-csv
            >
            <download-csv
              :data="arrayCargaCsv"
              class="v-btn primary v-btn--block text-center"
              v-if="arrayCargaCsv.length > 0 && false"
              :name="'carga_' + turno.toLowerCase() + '.csv'"
              >Archivo CSV para <br />horarios: Carga_{{
                turno.toUpperCase()
              }}</download-csv
            >
          </v-col>
          <v-col cols="12" sm="6" class="font-weight-bold" v-if="turno"
            ><p class="my-0 text-right">
              CARGA ACADÉMICA<br />
              TOTAL DEL TURNO: <u>{{ cargaTotal }} hrs.</u><br />
              ASIGNADAS:
              <u>{{ cargaAsignada }} hrs.</u>
            </p></v-col
          >
          <v-col
            cols="12"
            sm="6"
            class="font-weight-bold"
            v-if="turno && cargaNecesidad"
            ><p class="my-0">
              NECESIDAD:<br />
              TOTAL:
              <u>{{ cargaNecesidad }} hrs.</u><br />DEL SEMESTRE:
              <u>{{ cargaNecesidadSemestreSeleccionado }} hrs.</u>
            </p></v-col
          >
        </v-row>
      </v-card-text>
      <template>
        <v-tabs show-arrows fixed-tabs v-model="tabSelected">
          <v-tab v-for="(sem, idx) in itemsSemestres" :key="idx">
            {{ sem.text }}
          </v-tab>
        </v-tabs>
      </template>

      <v-divider />

      <v-card-text>
        <v-card v-for="grupo in itemsGrupos" :key="grupo.id" class="mb-4">
          <v-card-title class="secondary py-1"
            >Grupo
            {{
              grupo.semestre +
                "&deg; " +
                grupo.letra +
                " " +
                grupo.turno +
                " - " +
                grupo.nombre
            }}</v-card-title
          >
          <v-card-text>
            <v-row class="border-bottom">
              <v-col cols="12" sm="5"
                ><p class="text-center py-0 my-0">MATERIA / SUBMÓDULO</p></v-col
              >
              <v-col cols="3" sm="2"
                ><p class="text-center py-0 my-0">HORAS / SEMANA</p></v-col
              >
              <v-col cols="9" sm="5"
                ><p class="text-center py-0 my-0">DOCENTE</p></v-col
              >
            </v-row>
            <v-row
              v-for="c in itemsCarga(
                carga,
                grupo.turno,
                grupo.semestre,
                grupo.letra
              )"
              :key="c.id"
              align="center"
              class="border-top"
            >
              <v-col cols="12" sm="5">{{ c.nombre_materia }}</v-col>
              <v-col cols="3" sm="2"
                ><p class="text-center py-0 my-0">{{ c.horas }}</p></v-col
              >
              <v-col cols="9" sm="5"
                ><p class="text-center py-0 my-0">
                  <v-select
                    hide-details
                    v-model="c.docente_id"
                    :items="itemsDocentes"
                    required
                    @blur="docenteBlur"
                    @focus="docenteFocus(c.docente_id)"
                    @change="
                      docenteSeleccionado(
                        c.carga_id,
                        c.periodo_id,
                        c.grupo_id,
                        c.docente_id,
                        c.plan_estudio_id
                      )
                    "
                  /></p
              ></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>

    <loading-wait :loading="loading" />

    <v-snackbar v-model="snackbar" multi-line :timeout="snacktime">
      <v-row no-gutters>
        <v-col cols="12"
          ><strong>{{ docFocus ? docFocus.nombre : "" }}</strong></v-col
        >
        <v-col cols="6"
          >Plaza:
          <strong>{{ docFocus ? docFocus.plaza_horas : "" }}</strong>
          horas<br />Máximo frente a grupo:
          <strong>{{ docFocus ? docFocus.maximo_horas : "" }}</strong>
          horas</v-col
        >
        <v-col cols="6"
          >Asignado:<br />
          <ul>
            <li>
              <strong>{{ docFocus ? docFocus.grupos : "" }}</strong> grupo(s)
              para un total de
              <strong>{{ docFocus ? docFocus.horas : "" }}</strong> horas
            </li>
          </ul></v-col
        >
        <v-col cols="12"
          ><p
            class="error my-0"
            v-if="docFocus && docFocus.horas > docFocus.plaza_horas"
          >
            Se ha excedido el número de horas de la plaza.
          </p>
          <p
            class="info my-0"
            v-if="
              docFocus &&
                docFocus.horas <= docFocus.plaza_horas &&
                docFocus.horas > docFocus.maximo_horas
            "
          >
            Se ha excedido el número de horas frente a grupo.
          </p></v-col
        >
      </v-row>
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"
          >Cerrar</v-btn
        >
      </template>
    </v-snackbar>

    <loading-wait :loading="loading" />
  </v-container>
</template>

<script>
import api from "@/api";
import CargaCicloSemestre from "@/components/CargaCicloSemestre";
import LoadingWait from "@/components/LoadingWait.vue";
import { gets } from "@/mixins/gets";
import fn from "@/fn";

export default {
  name: "CargaAcademica",

  components: { CargaCicloSemestre, LoadingWait },

  props: {
    periodoSeleccionado: {
      type: String,
      required: true,
    },
  },

  mixins: [gets],

  data: () => ({
    periodoActual: true,
    periodo: {},
    grupos: {},
    carga: null,
    tutorias: {},
    docentes: {},
    turno: "",
    tabSelected: 0,
    loading: false,
    snackbar: false,
    snacktime: -1,
    docFocus: null,
    semsOrd: ["ERR", "1ER", "2DO", "3ER", "4TO", "5TO", "6TO", "ERR"],
  }),

  computed: {
    arrayClassroomCsv() {
      if (this.carga) {
        let items = this.carga;
        let iddocentes = this.docentesId;
        let semsOrd = this.semsOrd;
        let list = [];
        Object.keys(items).map(function(key) {
          list.push({
            Nombre_Clase:
              items[key].semestre +
              items[key].letra +
              "-" +
              items[key].turno +
              "-" +
              items[key].nombre_materia.toUpperCase(),
            Seccion: items[key].docente_id
              ? iddocentes[items[key].docente_id].nombre_apellidos
              : "",
            Materia:
              semsOrd[items[key].semestre] +
              " SEMESTRE-" +
              (items[key].nombre_materia.substr(0, 9) == "SUBMÓDULO"
                ? "SUBMÓDULO"
                : "ASIGNATURA"),
            Aula: items[key].nombre_carrera.toUpperCase(),
            Correo: items[key].docente_id
              ? iddocentes[items[key].docente_id].email
              : "",
          });
        });
        return list;
      }
      return [];
    },

    arrayCargaCsv() {
      if (this.carga) {
        let items = this.carga;
        let iddocentes = this.docentesId;
        let list = [];
        let result = Object.keys(items).map(function(key) {
          list.push({
            grupo: items[key].semestre + "-" + items[key].letra,
            materia: fn.quitaAcentos(
              items[key].nombre_materia.substr(0, 3) == "SUB"
                ? items[key].nombre_materia.substr(0, 11)
                : items[key].nombre_materia.toUpperCase()
            ),
            horas: items[key].horas,
            asignadas: 0,
            profesor: items[key].docente_id
              ? fn.quitaAcentos(
                  iddocentes[items[key].docente_id].nombre.toUpperCase()
                )
              : "_PROFESOR PENDIENTE",
            academia: fn.quitaAcentos(items[key].academia.toUpperCase()),
            submodulo: fn.quitaAcentos(
              items[key].nombre_materia.substr(0, 3) == "SUB"
                ? items[key].nombre_materia.substr(13).toUpperCase()
                : ""
            ),
          });
          return items[key];
        });
        return list;
      }
      return [];
    },

    cargaTxt() {
      let iddocentes = this.docentesId;
      let list = "[";
      let primero = true;
      if (this.carga) {
        let items = this.carga;
        let result = Object.keys(items).map(function(key) {
          if (!primero) {
            list += ",";
          } else primero = false;
          list +=
            '["' +
            items[key].semestre +
            "-" +
            items[key].letra +
            '","' +
            fn.quitaAcentos(
              items[key].nombre_materia.substr(0, 3) == "SUB"
                ? items[key].nombre_materia.substr(0, 11)
                : items[key].nombre_materia.toUpperCase()
            ) +
            '",' +
            items[key].horas +
            ',0,"' +
            (items[key].docente_id
              ? fn.quitaAcentos(
                  iddocentes[items[key].docente_id].nombre.toUpperCase()
                )
              : "_PROFESOR PENDIENTE") +
            '","' +
            fn.quitaAcentos(items[key].academia.toUpperCase()) +
            '","' +
            fn.quitaAcentos(
              items[key].nombre_materia.substr(0, 3) == "SUB"
                ? items[key].nombre_materia.substr(13).toUpperCase()
                : ""
            ) +
            '"]';
          return items[key];
        });
      }
      if (this.tutorias) {
        let items = this.tutorias;
        let result = Object.keys(items).map(function(key) {
          if (!primero) {
            list += ",";
          } else primero = false;
          list +=
            '["' +
            items[key].semestre +
            "-" +
            items[key].letra +
            '","TUTORIA",1,0,"' +
            (items[key].docente_id
              ? fn.quitaAcentos(
                  iddocentes[items[key].docente_id].nombre.toUpperCase()
                )
              : "_TUTOR PENDIENTE") +
            '","",""]';
          return items[key];
        });
      }
      list += "]";
      if (list === "[]") {
        return null;
      } else return list;
    },

    go_fetch() {
      let sel = null;
      if (this.turno != "") {
        sel = this.turno + "-" + this.tabSelected;
      }
      return sel;
    },

    cargaAsignada() {
      if (this.carga) {
        let items = this.carga;
        let total = 0;
        let result = Object.keys(items).map(function(key) {
          if (items[key].docente_id) total += parseInt(items[key].horas);
          return items[key];
        });
        return total;
      }
      return 0;
    },

    cargaNecesidad() {
      if (this.carga) {
        let items = this.carga;
        let total = 0;
        let result = Object.keys(items).map(function(key) {
          if (items[key].docente_id == null)
            total += parseInt(items[key].horas);
          return items[key];
        });
        return total;
      }
      return 0;
    },

    cargaNecesidadSemestreSeleccionado() {
      if (this.carga) {
        let items = this.carga;
        let selSems = this.itemsSemestres[this.tabSelected].value;
        let total = 0;
        let result = Object.keys(items).map(function(key) {
          if (items[key].semestre == selSems) {
            if (items[key].docente_id == null)
              total += parseInt(items[key].horas);
          }
          return items[key].semestre;
        });
        return total;
      }
      return 0;
    },

    cargaTotal() {
      if (this.carga) {
        let items = this.carga;
        let total = 0;
        let result = Object.keys(items).map(function(key) {
          total += parseInt(items[key].horas);
          return items[key];
        });
        return total;
      }
      return 0;
    },

    itemsGrupos() {
      if (this.go_fetch) {
        let items = this.grupos;
        let selSems = this.itemsSemestres[this.tabSelected].value;
        let list = [];
        let result = Object.keys(items).map(function(key) {
          if (items[key].semestre == selSems) list.push(items[key]);
          return items[key].semestre;
        });
        return list;
      } else return null;
    },
  },

  watch: {
    async go_fetch(val) {
      if (val) {
        this.carga = await this.get("cargas", {
          id: this.periodo.id,
          turno: this.turno,
        });
        this.tutorias = await this.get("tutorias", {
          id: this.periodo.id,
          turno: this.turno,
        });
        console.log(this.carga);
      }
    },

    periodoSeleccionado() {
      this.turno = "";
      this.set();
    },
  },

  methods: {
    downloadTxt() {
      let content = this.cargaTxt;
      let filename = "carga_" + this.turno.toLowerCase() + ".dat";

      let blob = new Blob([content], {
        type: "text/plain;charset=utf-8",
      });

      saveAs(blob, filename);
      return;
    },

    async set() {
      if (this.periodoSeleccionado == "proximo-periodo") {
        this.periodoActual = false;
      } else if (this.periodoSeleccionado == "periodo-actual") {
        this.periodoActual = true;
      }
      this.periodo = await this.get(
        "periodos",
        this.periodoActual ? "actual" : "proximo"
      );
      this.grupos = await this.getGrupos(this.periodo.id);
      this.docentes = await this.get("docentes", "all", "apellidos, nombre");
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Carga Académica");
    this.set();
  },
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid darkgray;
}
.border-top {
  border-top: 1px solid darkgray;
}
</style>
